<template>
    <div>
        <h3 class="text-center mb-3">Asignaturas</h3>
        <b-row class="my-3">
            <b-col cols="12">
                <b-button
                    variant="success"
                    class="float-right mx-2"
                    :to="{ name: 'admin-courses-create' }"
                >
                    <b-icon-plus /> Agregar
                </b-button>
                <b-button
                    v-if="adminSelectedCourse"
                    variant="warning"
                    class="float-right mx-2"
                    :to="{ name: 'admin-courses-edit', params: { courseCode: adminSelectedCourse.code } }"
                >
                    <b-icon-pencil /> Editar
                </b-button>
                <b-button
                    v-if="adminSelectedCourse"
                    variant="danger"
                    class="float-right mx-2"
                    @click="showDeleteModal = !showDeleteModal"
                >
                    <b-icon-trash-fill /> Eliminar
                </b-button>
            </b-col>
        </b-row>

        <AdminCoursesListCareerSelector />

        <AgGridVue
            floatingFilter
            style="width: 100%; height: 525px;"
            class="ag-theme-balham"
            rowSelection="single"
            rowDeselection
            pagination
            paginationAutoPageSize
            :columnDefs="columnDefs"
            :rowData="getActiveCareerCoursesList"
            :localeText="localeAgGridText"
            @grid-ready="onGridReady"
            @selection-changed="onSelectionChanged"
        />

        <b-modal
            id="modal-delete-course"
            ref="modal"
            title="Confirmar"
            centered
            v-model="showDeleteModal"
            ok-title="Confirmar"
            ok-variant="danger"
            cancel-title="Cancelar"
            @ok="onConfirmDeleteCourse"

        >
            ¿Esta seguro que desea eliminar la siguiente asignatura?
            <ul class="mt-3">
                <li v-if="adminSelectedCourse">
                    <b>Nombre:</b> {{ adminSelectedCourse.name }}
                </li>
                <li v-if="adminSelectedCourse">
                    <b>Código:</b> {{ adminSelectedCourse.code }}
                </li>
            </ul>
        </b-modal>
    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import AdminCoursesListCareerSelector from './AdminCoursesListCareerSelector'
import LocaleAgGridMixin from '../../mixins/localeAgGridMixin'

export default {
    name: 'AdminCoursesList',
    mixins: [LocaleAgGridMixin],
    data () {
        return {
            showDeleteModal: false,
            columnDefs: [
                { headerName: 'Código', field: 'code', sortable: true, sort: 'asc', filter: true, minWidth: 120, flex: 1 },
                { headerName: 'Nombre', field: 'name', sortable: true, filter: true, minWidth: 300, flex: 2 },
                { headerName: 'Créditos', field: 'creditUnits', sortable: true, filter: true, minWidth: 120, flex: 1 },
                { headerName: 'Tipo', field: 'type', sortable: true, filter: true, minWidth: 150, flex: 1 }
            ],
            gridApi: null
        }
    },
    components: {
        AgGridVue,
        AdminCoursesListCareerSelector
    },
    computed: {
        ...mapState([
            'adminPageActiveCareer',
            'adminSelectedCourse'
        ]),
        ...mapGetters([
            'getAdminPageFormattedCourses'
        ]),
        getActiveCareerCoursesList () {
            return this.getAdminPageFormattedCourses[this.adminPageActiveCareer]
        }
    },
    methods: {
        ...mapActions([
            'setAdminSelectedCourse',
            'deleteCourse',
            'getAllCourses'
        ]),
        onGridReady (params) {
            this.gridApi = params.api
        },
        onSelectionChanged () {
            var course = this.gridApi.getSelectedRows().pop(0)
            if (course) {
                this.setAdminSelectedCourse(course)
            } else {
                this.setAdminSelectedCourse(null)
            }
        },
        async onConfirmDeleteCourse () {
            let loader = null
            try {
                loader = this.$root.$loading.show()
                const courseCode = this.adminSelectedCourse.code
                await this.deleteCourse(courseCode)
                this.setAdminSelectedCourse(null)
                await this.getAllCourses()
                this.$root.successToast(`La asignatura ha sido eliminada exitosamente.`)
            } catch (err) {
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                loader.hide()
            }
        }
    },
    activated () {
        this.setAdminSelectedCourse(null)
        if (this.gridApi) {
            this.gridApi.deselectAll()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>
